<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">

    <div class="divider" v-if="variation.cnovaAttributes && variation.cnovaAttributes.some(attribute => attribute.name !== 'Selecione')"><span>Atributos</span></div>

    <div class="l-row" v-if=variation.cnovaAttributes>
      <form-group v-if="attribute.name !== 'Selecione'" v-for="(attribute, index) in variation.cnovaAttributes" :key="attribute.id" :label="attribute.name" :columns="3" :error="getError(attribute.id, variation.sku)" :required="attribute.required">
        <select v-model="attribute.value" class="form-select" :disabled="disabledInputs()" v-if="attribute.select">
          <option value="undefined">{{ $t('choose.label') }}</option>
          <option v-for="option in attribute.values" :value="option.text">{{ option.text }}</option>
        </select>

        <multiselect v-model="attribute.value" track-by="text" label="text" :options="attribute.values" :multiple="true" v-else-if="attribute.multiselect" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção"/>

        <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()" v-else>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    watch: {
      'variation.cnovaAttributes' (cnovaAttributes) {
        if (this.variation.cnovaAttributes.length) {
          this.variation.cnovaAttributes.forEach(cnovaAttribute => {
            let cnovaAttributeValue
            if (cnovaAttribute.name === 'Cor' && this.variation.attributes.color !== undefined) {
              const presetColor = this.$parent.$parent.$parent.getPresetItemByTypeAndFrom('color', { color: this.variation.attributes.color })
              if (presetColor !== null && presetColor !== undefined) {
                cnovaAttributeValue = cnovaAttribute.values.find(attributeValue => attributeValue.text.toLowerCase() === presetColor.color.toLowerCase())
              } else {
                cnovaAttributeValue = cnovaAttribute.values.find(attributeValue => attributeValue.text === this.variation.attributes.color)
              }
            } else if (cnovaAttribute.name === 'Tamanho' && this.variation.attributes.size !== undefined) {
              cnovaAttributeValue = cnovaAttribute.values.find(attributeValue => attributeValue.text === this.variation.attributes.size)
            }

            if (cnovaAttributeValue !== undefined) {
              cnovaAttribute.value = cnovaAttributeValue.id

              if (cnovaAttribute.name === 'Cor' || cnovaAttribute.name === 'Tamanho') {
                cnovaAttribute.value = cnovaAttributeValue.text
              }
            }
          })
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup,
      Multiselect
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?4a24dd0e